export const rol = {
    Admin: 'Admin',
    User: 'User'    
}